<div class="table-responsive">

    <a href="#" ng-click="collapseMenu()">
        <i class="fa fa-bars" style="font-size: 32px;"></i>
    </a>
    <!--<small class="pull-right pr10 total-record">Total Record : {{ data.orders.total }}</small>-->
    <!--<br>-->
    <!-- <dir-pagination-controls
            boundary-links="true"
            on-page-change="getPage(newPageNumber)"
            template-url="dirPagination.tpl.html"
            class="pagination-lg pagination pull-right pr10">
        Total Record {{data.orders.total }}
    </dir-pagination-controls> -->
    <div id="scrollable-area">
        <div ng-repeat="status in grouppedOrders" ng-if="(status.name == 'Scheduled Orders' && status.data.length > 0) || (status.name != 'Scheduled Orders')" class="mt-4 mb-5">
            <h4 style="margin-bottom: 0px; cursor: pointer;" ng-click="changeGroupShowStatus(status)">
                <i class="fa fa-arrow-down" ng-if="!status.show"></i>
                <i class="fa fa-arrow-up" ng-if="status.show"></i>
                {{ status.name }} ({{ status.data.length }}) <small style="font-size:12px">(Pickup : {{ getPickupCount(status) }})</small>
            </h4>
            <table class="table table-hover tc-checkbox-1" ng-show="status.show">
                <thead>
                <tr class="bg-light">
                    <th>
                    </th>
                    <th style="min-width: 150px;">
                        <!--Name And Email-->
                    </th>
                    <th class="text-center hide-tablet" style="min-width: 150px;"></th>
                    <th class="text-center"></th>
                    <th class="text-center"></th>
                    <th class="text-center">
                    </th>
                    <th class="text-center">
                    </th>
                </tr>
                </thead>
                <tbody>
                    <tr
                        ng-repeat="item in status.data"
                        ng-class="{'checked': selectedItems.indexOf(item.id) > -1}"
                    >
                    <td class="clickable-row">
                        <!-- <label class="option block mn" ng-if="item.status == 0 || item.status == null">
                            <input type="checkbox" ng-click="addSelectedItem(item.id)"
                                ng-checked="selectedItems.indexOf(item.id) > -1 || master" id="checkboxDefault-{{item.id}}">
                            <span class="checkbox mn"></span>
                        </label> -->
                    </td>
                    <td class="clickable-row" ng-click="getOrderDetails(item)">
                        <div class="avatar-container" style="align-items: center;">
                            <div class="avatar-img">
                                {{ item.location.name.split(' ')[0][0] }}{{ item.location.name.split(' ')[1][0] }}
                            </div>
                            <div class="avatar-detail">
                                <strong style="font-weight:bold; font-size: 19px;" class="fs21-tablet">{{ item.location.name }}</strong>
                                <div ng-if="item.status && item.status.value == 'last'">
                                    <p ng-if="item.location.phone_number">{{ item.location.phone_number | tel }}</p>
                                    <p class="mtn mbn" ng-if="!item.location.phone_number && item.uber_order_map.order_data.eater.phone">{{ item.uber_order_map.order_data.eater.phone | tel }}</p>
                                </div>
                            </div>
                        </div>
                    </td>
        
        
                    <td class="clickable-row text-center hide-tablet">
                        <!-- <p ng-if="item.location.phone_number">{{ item.location.phone_number | tel }}</p> -->
                        <a href="#" ng-click="printDeliveryOrder(item)"  ng-class="{ 'printed' : item.print_status == 'printed', 'not-printed' : item.print_status != 'printed' }">
                            <span ng-if="item.print_status == 'printed'">
                                <img src="/img/printed.svg" alt="" style="margin-right:8px; width:24px">
                                Reprint
                            </span>
                            <span ng-if="item.print_status != 'printed'">Print</span>
                        </a>

                        <!-- <p class="mtn mbn" ng-if="!item.location.phone_number && item.uber_order_map.order_data.eater.phone">{{ item.uber_order_map.order_data.eater.phone | tel }}</p> -->
                    </td>
        
                    <td class="clickable-row text-center" ng-click="getOrderDetails(item)">
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="item.uber_order_map">UberEats 
                            <span ng-if="item.uber_order_map.order_type === 'PICK_UP'"> - Pickup</span>
                            <span class="hide-tablet" style="display:none !important; text-transform: uppercase;">- {{item.uber_order_map.order_data.id.slice(-5)}}</span>
                        </strong>
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="item.imap_order_map">Grubhub 
                            <span ng-if="item.imap_order_map.order_type === 'PICK_UP'"> - Pickup</span>
                            <span class="hide-tablet" style="display:none !important; text-transform: uppercase;">- {{item.imap_order_map.mail_order_id.slice(-5)}}</span>
                        </strong>
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="item.big_commerce_order_map">BigCommerce <span class="hide-tablet" style="display:none !important; text-transform: uppercase;">- {{item.big_commerce_order_map.bigcommerce_order_id}}</span></strong>
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="item.doordash_order_map">Doordash <span class="hide-tablet" style="display:none !important; text-transform: uppercase;">- {{item.doordash_order_map.mail_order_id}}</span></strong>
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="item.delivery_mail_order_map">Delivery.com <span class="hide-tablet"delivery_mail_order_map style="display:none !important; text-transform: uppercase;">- {{item.doordash_order_map.mail_order_id}}</span></strong>
                        <strong style="font-weight:bold; font-size: 19px;color: #4a5157" class="fs21-tablet" ng-if="!item.imap_order_map && !item.uber_order_map && !item.big_commerce_order_map && !item.doordash_order_map && !item.delivery_mail_order_map">Manual</strong>
                    </td>
                    
                    <td class="clickable-row text-center" ng-click="getOrderDetails(item)" ng-if="!item.status || (item.status && item.status.value != 'last')">
                        <p ng-if="item.uber_order_map">{{ item.uber_order_map.store_name }} </p>
                        <p ng-if="item.imap_order_map">{{ item.imap_order_map.company }} </p>
                        <p ng-if="!item.imap_order_map && !item.uber_order_map">{{ authenticatedUser.customer_name }}</p>
                    </td>
                    
                    <td class="clickable-row text-center" ng-click="getOrderDetails(item)" style="display: flex; align-items: center; justify-content: center;">
                        <div class="remaining-time p10 m20" style="background: #eee">
                            <h5>{{ humanizeDurationMin(item.scheduled_time, 0) }}</h5> 
                        </div>
                        <strong>min</strong>
                        <!-- <span ng-if="item.scheduled_time">{{ item.scheduled_time | amDateFormat:'MM/DD/YYYY' }}</span> -->
                        <!-- <span ng-if="!item.scheduled_time">Flexible Date</span> -->
                    </td>


                    <td class="clickable-row text-center" ng-click="getOrderDetails(item)" ng-if="item.status && item.status.value == 'last'">
                        <p ng-if="!item.worker">{{ item.worker ? item.worker.full_name : 'Not Assigned' }} </p> 
                        <div class="avatar-container" style="align-items: center;" ng-if="item.worker">
                            <div class="avatar-detail">
                                <strong style="font-weight:bold; font-size: 19px;" class="fs21-tablet">{{ item.worker.full_name }}</strong>
                                <p ng-if="item.location.phone_number">{{ item.worker.phone_number | tel }}</p>
                            </div>
                        </div>
                    </td>
                    
                    <td class="clickable-row text-center" ng-click="getOrderDetails(item)" ng-if="item.status && item.status.value == 'last'">
                        <div class="avatar-container" style="align-items: center;" ng-if="item.estimated_delivery">
                            <div class="avatar-detail">
                                <strong style="font-weight:bold; font-size: 19px;" class="fs21-tablet">ETA {{ item.estimated_delivery | amDateFormat:'hh:mm A' }}</strong>
                            </div>
                        </div>
                        <span ng-if="!item.estimated_delivery">Calculating...</span>
                    </td>
        
                    <!--<td class="clickable-row text-center" ng-click="getOrderDetails(item)">{{ item.rate ? item.rate : '-' }}</td>-->
                    <!-- <td class="clickable-row text-center mw200" ng-click="getOrderDetails(item)">{{ item.name | cut:true:40:' ...' }}</td> -->
        
                    <td >
                        <div style="display: flex; align-items: center; justify-content: center; flex-direction: row;">
                            <!-- <div>
                                <div class="avatar-container" ng-if="item.status">
                                    <div class="avatar-detail">
                                        <span ng-if="item.status" ng-style="{'color': item.status.color }">{{ item.status.name }}</span>
                                        <span ng-if="item.status && item.status.value == 'last' && item.estimated_delivery">ETA {{ item.estimated_delivery | amDateFormat:'hh:mm A' }}</span>
                                        <span ng-if="item.status && item.status.value == 'last' && !item.estimated_delivery">Calculating...</span>
                                    </div>
                                </div>
                                <span ng-if="!item.status">Created</span>
                            </div> -->
                            <div ng-if="!item.status || (item.status && item.status.value !== 'last')">
                                <a href="" ng-click="changePackageType('large', item.id)" ng-if="item.package_type != 'large'" class="btn btn-operation ml-2">Large</a>
                                <a href="" ng-if="item.package_type == 'large'" class="btn btn-operation-success ml-2"> Large</a>
                            </div>
                            <div ng-if="!item.status || (item.status && item.status.value != 'last')">
                                <a href="" ng-click="changeStatus('accept', item.id)" ng-if="!item.accepted" class="btn btn-operation ml-2">Accept</a>
                            </div>
                            <div ng-if="!item.status || (item.status && item.status.value != 'last')">
                                <a href="" ng-click="changeStatus('prepared', item.id)" ng-if="!item.status" class="btn btn-prepared ml-2">Prepared</a>
                            </div>
                            <div ng-if="!item.status || (item.status && item.status.value != 'last')">
                                <a href="" ng-click="changeStatus('complete', item.id)" ng-if="((item.uber_order_map && item.uber_order_map.order_type === 'PICK_UP') || (item.imap_order_map && item.imap_order_map.order_type === 'PICK_UP')) && item.status && item.status.value === 'prepared'" class="btn btn-operation ml-2">Complete</a>
                            </div>
                        </div> 
                    </td>
                </tr>
                </tbody>
            </table>
            <div class="text-center mt50" ng-if="status.show && status.data.length === 0">
                <div ng-if="false">
                    <img src="img/empty_page_orange.svg" alt="" width="400px">
                    <br>
                    <h4>No orders yet</h4>
                </div>
                <h4>No orders yet</h4>
            </div>
        </div>
    </div>

    <div class="modal-dialog cancelled-orders" style="width: 400px;" ng-show="cancelledOrders.length > 0">
        <div class="modal-content">
            <div class="modal-body">
                <div class="text-center">
                    <img src="/img/danger-icon.svg" width="48px" style="margin: 0 auto;">
                    <div ng-repeat="item in cancelledOrders">
                        <h4>
                            Order <strong>{{ item.full_unique_id }}</strong> - <strong>{{ item.location.name }}</strong> was cancelled.
                            <a href="#" ng-click="getOrderDetails(item)" class="btn">
                                Show Order
                            </a>
                        </h4>
                        <hr>
                    </div>
                    <a href="#" class="btn" ng-click="closeCancelled()">
                        OK
                    </a>
                </div>
            </div>
        </div>
    </div>
</div>


